import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import HowToApplyUpgradation from "../../assets/pdf/how_to_apply_upgradation.pdf";
import HowToApplyNewShuttleLess from "../../assets/pdf/how_to_apply_newshuttleless.pdf";
import HowToApplyCFC from "../../assets/pdf/how_to_apply_cfc.pdf";
import { useState } from "react";

const HowToApply = () => {
  const { toast } = useToast();
  const [selectScheme, setSelectedScheme] = useState("");
  const [open, isOpen] = useState(false);

  const handleClick = (item) => {
    isOpen(true);
    setSelectedScheme(item);
  };

  const items = [
    {
      title:
        "Upgradation of 3-Year Old Conventional Powerloom into Rapier Shuttleless Loom",
      pdf: HowToApplyUpgradation,
    },
    {
      title:
        "Purchase of New Rapier Loom / Replacement of Existing Low-Speed Rapier Looms",
      pdf: HowToApplyNewShuttleLess,
    },
    {
      title: "Common Facility Centre",
      pdf: HowToApplyCFC,
    },
  ];

  return (
    <Card className="shadow-md border border-gray-200">
      <CardHeader className="bg-primary/10 rounded-t-lg">
        <CardTitle className="text-primary">How To Apply</CardTitle>
      </CardHeader>

      <CardContent className="space-y-6 pt-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {items.map((item, index) => (
            <Card
              key={index}
              onClick={() => handleClick(item)}
              className="cursor-pointer flex flex-col justify-between bg-white hover:shadow-md transition-shadow"
            >
              <CardHeader>
                <CardTitle className="text-primary text-lg">
                  {item.title}
                </CardTitle>
              </CardHeader>

              <CardContent>
                <div className="prose mt-6 prose-sm text-white text-center bg-primary p-3 rounded-md">
                  Click to view details
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>

      <Dialog open={open} onOpenChange={isOpen}>
        <DialogContent
          className="
          max-w-[90vw]
          w-[90vw]
          h-[90vh]
          p-0
          flex
          flex-col
        "
        >
          <DialogHeader className="px-6 py-4 border-b">
            <DialogTitle className="text-lg font-semibold">
              {selectScheme?.title}
            </DialogTitle>
          </DialogHeader>

          <div className="flex-1 overflow-hidden">
            {selectScheme?.pdf && (
              <iframe
                src={selectScheme?.pdf}
                title="PDF Preview"
                className="w-full h-full border-0"
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </Card>
  );
};

export default HowToApply;
